// Optimized custom_new.js - Lightweight version
// Removed embedded Swiper library to improve performance

// Accordion functionality
$(".accordion .question").click(function(){
  if($(this).parent(".accordion li").hasClass("open") == false) {
    $(".accordion .answer").slideUp();
    $(".accordion li").removeClass("open");
    
    $(this).next(".answer").slideDown();
    $(this).parent(".accordion li").addClass("open");
  } 
  else {
    $(".accordion .answer").slideUp();
    $(".accordion li").removeClass("open");
  }
});

// Testimonial Slider Initialization - only if Swiper is available
document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is loaded from external source
  if (typeof Swiper !== 'undefined') {
    
    // Page_lp_testimonial_slider 
    const testimonialSlider = document.querySelector('.Page_lp_testimonial_slider');
    if (testimonialSlider) {
      new Swiper('.Page_lp_testimonial_slider', {
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 0,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: ".Page_lp_testimonial_slider__next",
          prevEl: ".Page_lp_testimonial_slider__prev",
        }
      });
    }

    // Page_womens_testimonial_slider
    const womensSlider = document.querySelector('.Page_womens_testimonial_slider');
    if (womensSlider) {
      new Swiper('.Page_womens_testimonial_slider', {
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 0,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      });
    }
    
  } else {
    // Fallback: Load Swiper from CDN if not available
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
    script.onload = function() {
      // Re-run initialization after Swiper loads
      const event = new Event('DOMContentLoaded');
      document.dispatchEvent(event);
    };
    document.head.appendChild(script);
  }
});